<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back icon="chevron-back"></app-modal-back>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <mable-clean-slate-container *ngIf="searchResults$ | async as searchResults">
    <ion-toolbar class="slate-top">
      <ion-searchbar
        #searchbar
        [value]="searchString"
        (ionInput)="updateSearchResults($event.detail.value)"
        autocomplete="off"
        [placeholder]="placeholder"
        (ionClear)="clearAutocomplete()"
      ></ion-searchbar>
    </ion-toolbar>
    <div
      class="clean-slate"
      *ngIf="emptyScreenOnNoRecordsOnly ? searchbar.value && searchResults?.length === 0 : searchResults?.length === 0"
    >
      <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
    </div>
    <ion-list
      class="slate-bottom"
      *ngIf="searchResults?.length"
    >
      <ion-item
        *ngFor="let result of searchResults"
        class="ion-no-padding ion-margin-horizontal search-result-item"
        tappable
        (click)="selectSearchResult(result)"
      >
        {{ displayField ? result[displayField] : result }}
      </ion-item>
    </ion-list>
  </mable-clean-slate-container>
  <div
    aria-live="assertive"
    class="aria-invisible"
  >
    <p>{{ searchResultsAriaLive }}</p>
  </div>
</ion-content>
